/** Public root (`/`); behaviour matches `routes/_auth/_public/authenticate.tsx`. */
import { createFileRoute } from "@tanstack/react-router";

import { PublicSmartAuthLanding } from "@/features/auth/components/PublicSmartAuthLanding";
import { smartAuthLandingSearchSchema } from "@/features/auth/search/authRouteSearch";

const LandingPage = () => {
    return <PublicSmartAuthLanding search={Route.useSearch()} />;
};

export const Route = createFileRoute("/_auth/_public/")({
    component: LandingPage,
    validateSearch: (search) => smartAuthLandingSearchSchema.parse(search ?? {}),
});
